var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.874C24.8366 32.874 32 25.7106 32 16.874C32 8.03747 24.8366 0.874023 16 0.874023C7.16344 0.874023 0 8.03747 0 16.874C0 25.7106 7.16344 32.874 16 32.874Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30807 7.13235C2.05126 8.76754 1.10357 10.6522 0.551758 12.6997H8.87538L3.30807 7.13235Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4497 12.6997C30.8979 10.6523 29.9502 8.76763 28.6934 7.13244L23.1262 12.6997H31.4497Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.551758 21.0479C1.10363 23.0952 2.05132 24.9799 3.30807 26.615L8.8752 21.0479H0.551758Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7418 4.18127C24.1066 2.92446 22.222 1.97677 20.1746 1.4249V9.74846L25.7418 4.18127Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26025 29.5666C7.89544 30.8234 9.78013 31.7711 11.8275 32.323V23.9995L6.26025 29.5666Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8274 1.4249C9.78007 1.97677 7.89538 2.92446 6.26025 4.18121L11.8274 9.7484V1.4249Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 32.323C22.2212 31.7711 24.1059 30.8234 25.741 29.5666L20.1738 23.9995V32.323Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1262 21.0479L28.6934 26.6151C29.9502 24.98 30.8979 23.0952 31.4497 21.0479H23.1262Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 14.7871H18.0871H18.087V1.00946C17.4038 0.920523 16.7073 0.874023 16 0.874023C15.2926 0.874023 14.5962 0.920523 13.9131 1.00946V14.787V14.787H0.135438C0.0465 15.4702 0 16.1667 0 16.874C0 17.5815 0.0465 18.2778 0.135438 18.961H13.9129H13.913V32.7386C14.5962 32.8275 15.2926 32.874 16 32.874C16.7073 32.874 17.4038 32.8276 18.0869 32.7386V18.9611V18.961H31.8646C31.9535 18.2778 32 17.5815 32 16.874C32 16.1667 31.9535 15.4702 31.8646 14.7871V14.7871Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 21.0478L27.3136 28.1876C27.642 27.8593 27.9552 27.5161 28.2541 27.1604L22.1415 21.0478H20.1738V21.0478Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8256 21.0479H11.8255L4.68579 28.1875C5.01404 28.5159 5.35723 28.8292 5.71298 29.128L11.8256 23.0153V21.0479Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8256 12.6998V12.6997L4.68586 5.55984C4.35749 5.88809 4.04424 6.23128 3.74536 6.58703L9.85805 12.6997H11.8256V12.6998Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 12.7006L27.3136 5.56072C26.9854 5.23234 26.6422 4.91909 26.2865 4.62028L20.1738 10.733V12.7006Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.874023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/united-kingdom.30e8293d.svg";
export { ForwardRef as ReactComponent };